// extracted by css-extract-rspack-plugin
export default {"cls1":"ChurnedUserReactivationButton-cls1_aeU","cls2":"ChurnedUserReactivationButton-cls2_ms_ ChurnedUserReactivationButton-cls1_aeU"};